export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./aggregator.vue?vue&type=template&id=65c4047b&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/games/aggregator.vue?vue&type=template&id=65c4047b&scoped=true
// module id = zHa2
// module chunks = 0